import styled from 'styled-components';

const ICON_STYLES = {
  WIDTH: '46px',
  HEIGHT: '46px',
};

const VjsComponentWrapper = styled.div`
  height: 100%;
  width: 100%;
  && {
    background-color: transparent;
  }

  .vjs-control.vjs-button {
    width: ${ICON_STYLES.WIDTH};
    height: ${ICON_STYLES.HEIGHT};
  }

  /* SeekButton */
  .vjs-control.vjs-seek-button {
  }

  /* VolumePanel */
  .vjs-volume-panel.vjs-control.vjs-volume-panel-vertical {
    height: fit-content;
    position: relative;
    width: fit-content;
    .vjs-volume-control.vjs-control.vjs-volume-vertical {
      position: absolute;
      bottom: ${ICON_STYLES.HEIGHT};
      left: 50%;
      transform: translateX(-50%);
    }
    @media (hover: none) {
      .vjs-volume-control.vjs-control.vjs-volume-vertical {
        display: none;
      }
    }

    .vjs-button {
      padding: 0;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      padding-top: 0;
    }
    .vjs-volume-level {
      background-color: ${({ theme }) => theme.colors.primary};
    }
  }

  /* PlayToggle */
  .vjs-control.vjs-play-control {
  }

  /* ProgressControl */
  .vjs-control.vjs-progress-control {
    width: 100%;
    position: unset;
    .vjs-play-progress.vjs-slider-bar {
      background-color: ${({ theme }) => theme.colors.primary};
    }
  }

  /* CurrentTime && Duration */
  .vjs-control.vjs-time-control {
    width: 64px;
    flex-shrink: 0;
  }

  /* PlaybackRateMenuButton */
  .vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button {
    height: 100%;

    .vjs-menu-button {
      width: ${ICON_STYLES.WIDTH};
      height: ${ICON_STYLES.HEIGHT};
      position: relative;
      padding: 0;
    }
    .vjs-menu {
      left: 50%;
      transform: translateX(-50%);
      bottom: 10px;
    }
    @media (hover: none) {
      &:hover {
        .vjs-menu {
          display: none;
        }
      }
    }
  }

  .vjs-playback-rate > .vjs-menu > .vjs-menu-content {
    max-height: fit-content;
  }
`;

export default VjsComponentWrapper;
